/* Easter egg : 10 clics sur l'icône du paresseux révèlent un code promo */
(function () {
  var CLICKS_NEEDED = 10;
  var HEARTS = ['❤', '💕', '💗', '💖'];

  function burst(button, count) {
    var rect = button.getBoundingClientRect();
    for (var i = 0; i < count; i++) {
      var heart = document.createElement('span');
      heart.className = 'egg-heart';
      heart.textContent = HEARTS[Math.floor(Math.random() * HEARTS.length)];
      heart.style.left = rect.left + rect.width / 2 + 'px';
      heart.style.top = rect.top + rect.height / 2 + 'px';
      heart.style.setProperty('--dx', (Math.random() * 160 - 80).toFixed(0) + 'px');
      heart.style.setProperty('--dy', (-70 - Math.random() * 90).toFixed(0) + 'px');
      heart.style.setProperty('--rot', (Math.random() * 60 - 30).toFixed(0) + 'deg');
      heart.style.fontSize = (1 + Math.random() * 0.9).toFixed(2) + 'rem';
      heart.style.animationDelay = (i * 40) + 'ms';
      document.body.appendChild(heart);
      heart.addEventListener('animationend', function () { this.remove(); });
    }
  }

  function openPopup(code) {
    var dialog = document.querySelector('.egg-dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'egg-dialog';
      dialog.innerHTML =
        '<button type="button" class="egg-dialog__close" aria-label="Fermer">×</button>' +
        '<p class="egg-dialog__emoji" aria-hidden="true">💖</p>' +
        '<h2 class="egg-dialog__title">Vous l’avez trouvé !</h2>' +
        '<p class="egg-dialog__text">Tant de câlins méritent une récompense : <strong>-5 % en plus</strong> sur votre commande.</p>' +
        '<div class="egg-dialog__code"><span class="egg-dialog__value"></span>' +
        '<button type="button" class="button button--primary egg-dialog__copy">Copier</button></div>' +
        '<p class="egg-dialog__hint">À saisir au moment du paiement.</p>';
      document.body.appendChild(dialog);
      dialog.querySelector('.egg-dialog__close').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.querySelector('.egg-dialog__copy').addEventListener('click', function () {
        var btn = this;
        var value = dialog.querySelector('.egg-dialog__value').textContent;
        var done = function () { btn.textContent = 'Copié ✓'; setTimeout(function () { btn.textContent = 'Copier'; }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(value).then(done, done);
        else {
          var range = document.createRange();
          range.selectNodeContents(dialog.querySelector('.egg-dialog__value'));
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
          try { document.execCommand('copy'); } catch (e) {}
          done();
        }
      });
    }
    dialog.querySelector('.egg-dialog__value').textContent = code;
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  }

  document.querySelectorAll('[data-egg-code]').forEach(function (button) {
    var clicks = 0;
    button.addEventListener('click', function () {
      clicks++;
      button.classList.remove('is-squeezed');
      void button.offsetWidth;
      button.classList.add('is-squeezed');
      burst(button, clicks >= CLICKS_NEEDED ? 16 : 3);
      if (clicks >= CLICKS_NEEDED) {
        clicks = 0;
        setTimeout(function () { openPopup(button.dataset.eggCode); }, 450);
      }
    });
  });
})();
